import * as React from "react";
import { useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Input, InputProps, Label, makeStyles, Text, tokens } from "@fluentui/react-components";
import { getUsers } from "../services/AuctionService";
import { IAuction } from "../models/auction";
import { DeleteFilled, EditFilled, MailFilled } from "@fluentui/react-icons";
import { IProfile, IUser } from "../models/profile";

export const UserList = () => {
  const [users, setUsers] = useState<IUser[]>([]);
  const [open, setOpen] = useState(false);
  const [auction, setAuction] = useState<IAuction>();
  const [error, setError] = useState('');
  const [jersey, setJersey] = useState<string>();
  const [team, setTeam] = useState<string>();
  const [name, setName] = useState<string>();

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const result = await getUsers();
      console.log(result);
      setUsers(result);
    };
    fetchData().catch(console.error)
  }, []);
 
  return (
    <div className="container">
      <div className="page-title">GESTIONE UTENTI</div>
      {
        users.map((a: IUser) => {
        return (
          <>
            <div key={a.ID} className="row">
              <div className="col-8">
                <span><MailFilled /></span> {a.UserName}
              </div>         
              <div className="col-4 listButtonRow">
                <Button icon={<DeleteFilled/>} ></Button>
              </div>
            </div>
            <div key={a.ID} className="row">
              <div className="col-12">
                {a.LastName} {a.FirstName} ({a.DisplayName})
              </div>
            </div>
            <div className="col-12" style={{borderBottom: '1px solid #ccc', margin:'10px 0 10px 0'}}></div>
          </>
        )})
      }
      {/* <table className="table table-sm">
        <thead>
          <tr>            
            <th scope="col">Username</th>
            <th scope="col">DisplayName</th>
            <th scope="col">Nome</th>
            <th scope="col">Cognome</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {
            users.map((a:IUser) => {
              return (
                <tr key={a.ID}> 
                  <td className="td400">{a.UserName}</td>
                  <td>{a.DisplayName}</td>
                  <td>{a.FirstName}</td>
                  <td>{a.LastName}</td>
                  <td className="td100">

                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table> */}      
    </div>
  );
};